import React, { memo, useCallback, useEffect, useRef, useState } from 'react';
import styles from './WpProductDetail.module.less';
import Dialog from '../Dialog/Modal';
import { imgLocalUrl, createAxios, logNative } from '../../utils/utils';
import { createSelector } from 'reselect';
import { WP_PRODUCT_PAY_CREATE_80, CONTEXT } from '../../config';
import QRCode from 'qrcode.react';
import Btn from '../Btn/Btn';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { logging } from '../../actions/log';
import Toast from '../Toast/Toast';
import { PCStoreJsBridge } from '../../nativeapi';
import { updatePreviewInfo } from '../../actions/wallpaper';

const selectUserInfo = createSelector(
  state => state.user,
  user => user.userInfo,
);
const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
/**
 * callback 预览壁纸时跳转卡片前 退出预览
 */
export default memo(
  ({ handleClose = () => {}, wallpaper, callback = () => {}, errMsg = '壁纸下载失败' }) => {
    const repeatTimer = useRef(null);
    const userInfo = useSelector(selectUserInfo) || {};
    const [productInfo, setProductInfo] = useState(null);
    // 值main: 当前壁纸 recommend 推荐的其他壁纸
    const [activeWp, setActiveWp] = useState(wallpaper?.type !== 2 ? 'main' : 'recommend');
    const [payResult, setPayResult] = useState(null);
    const history = useHistory();
    const logInfoData = useSelector(selectLogInfo);
    const dispatch = useDispatch();
    const failToast = useCallback(() => {
      Toast.error({
        content: errMsg,
      });
    }, []);
    const handlePvlog = useCallback(
      num => {
        dispatch(
          logging({
            category: 'Wallpaper',
            action: 'P_Wallpaper_Buy',
            label: '',
            param2: {
              source: `${logInfoData.source}`,
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
              wallpaperId: wallpaper.type === 2 ? wallpaper.code : wallpaper.wallpaperId,
              wptype: wallpaper.type,
              sku: wallpaper.type === 2 ? 1 : num,
            },
            param3: wallpaper?.bizInfo || '{}',
          }),
        );
      },
      [logInfoData, wallpaper, productInfo],
    );
    const handleTabLog = useCallback(() => {
      dispatch(
        logging({
          category: 'Wallpaper',
          action: 'C_Wallpaper_Buy',
          label: '',
          param2: {
            source: `${logInfoData.source}`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            wallpaperId: wallpaper.type === 2 ? wallpaper.code : wallpaper.wallpaperId,
            wptype: wallpaper.type,
            sku: wallpaper.type === 2 ? 1 : productInfo?.goodRecommend ? 2 : 1,
          },
          param3: wallpaper?.bizInfo || '{}',
        }),
      );
    }, [logInfoData, wallpaper, productInfo]);

    const handleCancelDialog = useCallback(() => {
      handleClose();
    }, []);

    const getPayInfo = useCallback(async () => {
      try {
        const axios = await createAxios('isNeedUser');

        // type ===  wallpaper  对于免费壁纸的设置的下载
        // type ===  preview   对于（免费和付费）壁纸的预览的下载
        // type ===    对于付费壁纸的设置的下载
        let type = 1;
        if (
          wallpaper?.type &&
          (wallpaper?.type === 'wallpaper' ||
            wallpaper?.type === 'wallpaper' ||
            wallpaper?.type === 'wallpaper')
        ) {
          type = 1;
        } else {
          type = wallpaper?.type === 2 ? 2 : 1;
        }
        const {
          data: { data, status },
        } = await axios.post(WP_PRODUCT_PAY_CREATE_80, {
          appType: '12',
          goodsType: 'wallpaper',
          skuId: wallpaper?.type === 2 ? wallpaper?.code : wallpaper?.wallpaperId,
          type: type,
        });
        if (status == 0) {
          setProductInfo({
            ...data,
            goodRecommend:
              wallpaper.type === 2
                ? {
                    ...data,
                    ...wallpaper,
                  }
                : data.goodRecommend,
          });
          handlePvlog(data.goodRecommend ? 2 : 1);
        } else {
          failToast();
          handleCancelDialog();
        }
      } catch (err) {
        failToast();
        handleCancelDialog();
        logNative(err);
      }
    }, [wallpaper]);

    const handleActiveCard = useCallback(
      type => () => {
        if (activeWp !== type) {
          handleTabLog();
        }
        setActiveWp(type);
      },
      [activeWp, productInfo],
    );

    /**
     * price :价格单位是分
     */
    const handlePrice = useCallback((price = 0) => {
      return parseFloat(+price / 100);
    }, []);

    const getPayResult = useCallback(async () => {
      try {
        const axios = await createAxios('isNeedUser');
        const {
          data: { data, status },
        } = await axios.get(
          activeWp === 'main' ? productInfo?.queryUrl : productInfo?.goodRecommend?.queryUrl,
        );

        if (status === 10) {
          //付款成功
          setPayResult(data);
          clearInterval(repeatTimer.current);
        } else if (status !== -2) {
          setPayResult({
            ...(data || {
              orderStatus: -5,
            }),
          });
          clearInterval(repeatTimer.current);
        }
      } catch (err) {
        // setPayResult({
        //   orderStatus: -5,
        // });
        clearInterval(repeatTimer.current);
      }
    }, [productInfo, activeWp]);

    const handelMoreWp = useCallback(
      e => {
        e.stopPropagation();
        clearInterval(repeatTimer.current);
        // callback();
        let type = sessionStorage.getItem('PCStoreIsMaximize');
        if (type !== '1') {
          PCStoreJsBridge.wpExitMaximizeStroe().then(ret => {
            if (ret.succ) {
              dispatch(updatePreviewInfo(null));
            }
          });
        }
        handleCancelDialog();
        history.push(`${CONTEXT}/wprank?code=${productInfo?.goodRecommend?.skuId}`);
      },
      [productInfo],
    );

    const handleSkipStatement = useCallback(() => {
      window.open('https://s1.lenovomm.cn/pcstore/html/wallpaper.html', '_blank');
    }, []);

    useEffect(() => {
      getPayInfo();
    }, []);

    useEffect(() => {
      if (productInfo) {
        clearInterval(repeatTimer.current);
        repeatTimer.current = setInterval(getPayResult, 2000);
      }
    }, [activeWp, productInfo]);

    useEffect(() => {
      return () => {
        clearInterval(repeatTimer.current);
      };
    }, []);

    if (!productInfo) {
      return null;
    }

    return (
      <div onClick={e => e.stopPropagation()}>
        <Dialog
          title="购买壁纸"
          maskStyle={styles.mask}
          containerStyle={styles.containerStyle}
          handleClose={handleCancelDialog}
        >
          <div className={styles.title} />
          {!payResult && (
            <div className={styles.pay_container}>
              <div className={styles.user}>
                <img
                  src={
                    userInfo.headimgurl
                      ? userInfo.headimgurl.indexOf('http') > -1
                        ? userInfo.headimgurl
                        : imgLocalUrl(userInfo.headimgurl)
                      : require('../../static/face.png')
                  }
                  className={styles.user_img}
                />
                <div className={styles.user_info}>
                  <div className={styles.user_name}>
                    Hi，
                    {userInfo.sensitiveNickName ||
                      userInfo.lidNickName ||
                      userInfo.uname ||
                      userInfo.uName}
                  </div>
                  <div>
                    应版权方要求，该壁纸需付费设置和下载。支付成功后可设为桌面壁纸并支持下载到本地。{' '}
                  </div>
                </div>
              </div>
              <div className={styles.product}>
                {/* 单张壁纸 */}
                {wallpaper?.wallpaperId && wallpaper?.type !== 2 && (
                  <div
                    className={`${styles.product_card} ${activeWp === 'main' ? styles.active : ''}`}
                    onClick={handleActiveCard('main')}
                  >
                    <div className={styles.product_card_title}>单张壁纸</div>
                    <div className={styles.product_card_id}>ID：{wallpaper.wallpaperId}</div>
                    <div className={styles.product_card_price_container}>
                      <div className={styles.product_card_price}>
                        <div className={styles.product_card_price_now}>
                          <span>&#165;</span>
                          {handlePrice(wallpaper.nowPrice || wallpaper.originalPrice)}
                        </div>
                        {wallpaper.nowPrice && (
                          <div className={styles.product_card_price_origin}>
                            &#165; {handlePrice(wallpaper.originalPrice)}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
                {/* 壁纸包 */}
                {productInfo?.goodRecommend && (
                  <div
                    className={`${styles.product_card} ${
                      activeWp === 'recommend' ? styles.active : ''
                    }`}
                    onClick={handleActiveCard('recommend')}
                  >
                    {productInfo?.goodRecommend?.marketingDesc && (
                      <div className={styles.product_card_marketingDesc}>
                        {productInfo?.goodRecommend?.marketingDesc}
                      </div>
                    )}
                    <div className={styles.product_card_title}>
                      {productInfo?.goodRecommend?.name}
                    </div>
                    <div className={styles.product_card_link}>
                      {wallpaper.type !== 2 && (
                        <>
                          <label className={styles.product_card_link_desc}>含该张壁纸</label>
                          <label className={styles.product_card_link_detail} onClick={handelMoreWp}>
                            查看
                            <i className="iconfont icon-point_right" />
                          </label>
                        </>
                      )}
                    </div>
                    <div className={styles.product_card_price_container}>
                      <div className={styles.product_card_price}>
                        <div className={styles.product_card_price_now}>
                          <span>&#165;</span>
                          {handlePrice(
                            productInfo?.goodRecommend?.nowPrice ||
                              productInfo?.goodRecommend?.originalPrice,
                          )}
                        </div>
                        {productInfo?.goodRecommend?.nowPrice && (
                          <div className={styles.product_card_price_origin}>
                            &#165; {handlePrice(productInfo?.goodRecommend?.originalPrice)}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className={styles.pay}>
                {/* 单张壁纸直接去wallperper 否则取productInfo */}
                <div className={styles.pay_img}>
                  {/* <img src={activeWp == 'main' ? productInfo?.payUrl : productInfo?.goodRecommend?.payUrl} /> */}
                  <QRCode
                    className="qrcode_image"
                    size={102}
                    level="Q"
                    value={
                      activeWp == 'main' ? productInfo?.payUrl : productInfo?.goodRecommend?.payUrl
                    }
                  />
                </div>
                <div>
                  <div className={styles.pay_info}>
                    <div className={styles.pay_info_now_price}>
                      &#165;&nbsp;
                      {activeWp == 'main'
                        ? handlePrice(wallpaper?.nowPrice || wallpaper?.originalPrice)
                        : handlePrice(
                            productInfo?.goodRecommend?.nowPrice ||
                              productInfo?.goodRecommend?.originalPrice,
                          )}
                    </div>
                    {(activeWp == 'main'
                      ? !!wallpaper.nowPrice
                      : !!productInfo?.goodRecommend?.nowPrice) && (
                      <>
                        <div className={styles.pay_info_origin_price}>
                          &#165;
                          {activeWp == 'main'
                            ? handlePrice(wallpaper?.originalPrice)
                            : handlePrice(productInfo?.goodRecommend?.originalPrice)}
                        </div>
                        <div className={styles.pay_info_discount_price}>
                          已优惠
                          {handlePrice(
                            activeWp == 'main'
                              ? wallpaper?.originalPrice - wallpaper?.nowPrice
                              : productInfo?.goodRecommend?.originalPrice -
                                  productInfo?.goodRecommend?.nowPrice,
                          )}
                          元
                        </div>
                      </>
                    )}
                  </div>
                  <div className={styles.pay_info_type}>
                    <div className={styles.pay_info_type_wechat}>
                      <img src={require('../../static/wp_wechat.svg')} />
                      <label>微信</label>
                    </div>
                    <div className={styles.pay_info_type_zhifubao}>
                      <img src={require('../../static/wp_zhifubao.svg')} />
                      <label>支付宝</label>
                    </div>
                  </div>
                  <div className={styles.pay_info_other}>该商品为虚拟商品，不接受退换</div>
                  <div className={styles.pay_info_statement}>
                    购买即代表您已阅读并同意
                    <label onClick={handleSkipStatement}>《非商业用途声明》</label>
                  </div>
                </div>
              </div>
            </div>
          )}
          {payResult && (
            <div className={styles.result}>
              <img
                src={require(payResult.orderStatus === 10
                  ? '../../static/wp_pay_succ.svg'
                  : '../../static/wp_pay_fail.svg')}
                className={styles.result_img}
              />
              <div className={styles.result_pay}>
                {payResult.orderStatus === 10 ? '支付成功' : '支付失败'}
              </div>
              <div className={styles.result_desc}>
                {payResult.orderStatus === 10
                  ? '您可在“我的壁纸”查看购买订单'
                  : '购买遇到异常请您重新购买'}
              </div>
              <Btn primary className={styles.result_btn} handleClick={handleCancelDialog}>
                我知道了
              </Btn>
            </div>
          )}
        </Dialog>
      </div>
    );
  },
);
